import { render, staticRenderFns } from "./trashDeleteBin.vue?vue&type=template&id=fc659a96&"
import script from "./trashDeleteBin.vue?vue&type=script&lang=js&"
export * from "./trashDeleteBin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports